var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 52 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7327 28.5266C49.7223 28.4912 49.712 28.4559 49.6992 28.4205C49.6992 28.4205 48.4108 25.0837 47.7324 23.7691C47.683 23.6551 47.6124 23.5515 47.5118 23.3949C47.1888 22.8915 46.4758 22.7835 45.9833 22.9615C45.5816 23.106 45.3506 23.3778 45.2191 23.735C44.8716 22.9457 44.0482 22.6117 43.2942 22.8908C42.8127 23.0694 42.499 23.4613 42.3624 23.9294C41.9614 23.2669 41.1935 23.0042 40.4871 23.2663C39.8721 23.4936 39.4821 24.0531 39.4748 24.6985L37.611 19.6673C37.2825 18.7812 36.4115 18.287 35.665 18.5636C34.9183 18.8403 34.5789 19.7826 34.9074 20.6693L38.1718 29.4804C37.7756 28.9934 37.4203 28.5656 37.1564 28.2663C36.2153 27.1998 35.0006 26.7799 34.2973 27.2248C33.2466 27.8897 34.7458 29.3945 35.5851 30.6531C36.2745 31.6867 37.6665 33.6236 38.0687 34.0679C38.7708 34.8431 39.4479 35.4733 40.033 35.8506C41.9357 37.2578 44.1251 37.3633 46.2057 36.5929C48.7278 35.658 51.3887 32.9825 49.7376 28.5248L49.7327 28.5266Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5427 33.5558C22.5427 31.6463 20.9952 30.0989 19.0865 30.0989H1.4917V28.6813V1.38379H19.0865C20.9952 1.38379 22.5427 2.93124 22.5427 4.84009V28.6813V33.5558Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5936 19.6868V1.38379H25.9988C24.0899 1.38379 22.5425 2.93124 22.5425 4.84009V28.6813V33.5558C22.5425 31.6463 24.0899 30.0989 25.9988 30.0989H30.7715",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.5229,
    y1: 8.09424,
    x2: 7.4639,
    y2: 8.09424,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5229,
    y1: 12.375,
    x2: 7.4639,
    y2: 12.375,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5229,
    y1: 16.6558,
    x2: 7.4639,
    y2: 16.6558,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 37.5605,
    y1: 8.09424,
    x2: 28.5015,
    y2: 8.09424,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 37.5605,
    y1: 12.375,
    x2: 28.5015,
    y2: 12.375,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 32.0566,
    y1: 16.6558,
    x2: 28.5013,
    y2: 16.6558,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 16.5229,
    y1: 20.9365,
    x2: 7.4639,
    y2: 20.9365,
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.550c9c29331b224fb2fe100feb29582a.svg";
export { ForwardRef as ReactComponent };